import { defineMixin } from '../vue'

export const mpMixin = defineMixin({






})

export default mpMixin

